__turbopack_context__.v({
  "backdrop": "HelpModal-module__rNdkXq__backdrop",
  "card": "HelpModal-module__rNdkXq__card",
  "close": "HelpModal-module__rNdkXq__close",
  "footer": "HelpModal-module__rNdkXq__footer",
  "heading": "HelpModal-module__rNdkXq__heading",
  "kbd": "HelpModal-module__rNdkXq__kbd",
  "keys": "HelpModal-module__rNdkXq__keys",
  "list": "HelpModal-module__rNdkXq__list",
  "row": "HelpModal-module__rNdkXq__row",
  "section": "HelpModal-module__rNdkXq__section",
  "sectionTitle": "HelpModal-module__rNdkXq__sectionTitle",
  "tab": "HelpModal-module__rNdkXq__tab",
  "tabOn": "HelpModal-module__rNdkXq__tabOn",
  "tabs": "HelpModal-module__rNdkXq__tabs",
});
